import { salesPersonConstants } from "../constants/salesPersonConstants";
import { salesPersonService } from "../../services/API/salesPersonService";

export const salesPersonActions = {
  getSalesManager,
  getSalesPersons,
  add_cityAccess,
  getSalesPersonCities,
  promote_salesPerson,
  getQuestionsList,
  getSalesPersonReport,
  getCititesForReport,
  getSalesPersonQuestDetail,
  updateAnswer,
  getSalesPersonExportReport,
  gethelpdetail,
  addHelpQuestion,
  updateHelpReply,
  getMonthandYear,
  getProgressReport
};

function getSalesManager() {
  return dispatch => {
    dispatch(request());
    salesPersonService.getSalesManager().then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: salesPersonConstants.GET_SALESMANAGER_REQUEST, data };
  }
  function success(data) {
    return { type: salesPersonConstants.GET_SALESMANAGER_SUCCESS, data };
  }
  function failure(error) {
    return { type: salesPersonConstants.GET_SALESMANAGER_FAILURE, error };
  }
}

export const getSalesPersons = () => {
  return dispatch => {
    dispatch(request());
    salesPersonService.getSalesManager().then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: salesPersonConstants.GET_SALESMANAGER_REQUEST, data };
  }
  function success(data) {
    return { type: salesPersonConstants.GET_SALESMANAGER_SUCCESS, data };
  }
  function failure(error) {
    return { type: salesPersonConstants.GET_SALESMANAGER_FAILURE, error };
  }
};

export const add_cityAccess = postData => {
  return dispatch => {
    salesPersonService.add_cityAccess(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: salesPersonConstants.ADD_CITY_ACCESS_REQUEST, data };
  }
  function success(data) {
    return { type: salesPersonConstants.ADD_CITY_ACCESS_SUCCESS, data };
  }
  function failure(error) {
    return { type: salesPersonConstants.ADD_CITY_ACCESS_FAILURE, error };
  }
};

export const getSalesPersonCities = postaData => {
  return dispatch => {
    dispatch(request());
    salesPersonService.getSalesPersonCities(postaData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: salesPersonConstants.GET_SALESMANAGER_CITIES_REQUEST, data };
  }
  function success(data) {
    return { type: salesPersonConstants.GET_SALESMANAGER_CITIES_SUCCESS, data };
  }
  function failure(error) {
    return {
      type: salesPersonConstants.GET_SALESMANAGER_CITIES_FAILURE,
      error
    };
  }
};

export const promote_salesPerson = postData => {
  return dispatch => {
    salesPersonService.promote_salesPerson(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: salesPersonConstants.PROMOTE_SALESPERSON_REQUEST, data };
  }
  function success(data) {
    return { type: salesPersonConstants.PROMOTE_SALESPERSON_SUCCESS, data };
  }
  function failure(error) {
    return { type: salesPersonConstants.PROMOTE_SALESPERSON_FAILURE, error };
  }
};

export const getQuestionsList = postaData => {
  return dispatch => {
    dispatch(request());
    salesPersonService.getQuestionsList(postaData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return {
      type: salesPersonConstants.GET_SALESMANAGER_QUESTIONS_REQUEST,
      data
    };
  }
  function success(data) {
    return {
      type: salesPersonConstants.GET_SALESMANAGER_QUESTIONS_SUCCESS,
      data
    };
  }
  function failure(error) {
    return {
      type: salesPersonConstants.GET_SALESMANAGER_QUESTIONS_FAILURE,
      error
    };
  }
};

export const getSalesPersonReport = postaData => {
  return dispatch => {
    dispatch(request());
    salesPersonService.getSalesPersonReport(postaData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: salesPersonConstants.GET_SALESMANAGER_REPORT_REQUEST, data };
  }
  function success(data) {
    return { type: salesPersonConstants.GET_SALESMANAGER_REPORT_SUCCESS, data };
  }
  function failure(error) {
    return {
      type: salesPersonConstants.GET_SALESMANAGER_REPORT_FAILURE,
      error
    };
  }
};

export const getSalesPersonExportReport = postaData => {
  return dispatch => {
    dispatch(request());
    salesPersonService.getSalesPersonExportReport(postaData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return {
      type: salesPersonConstants.GET_SALESMANAGER_EXPORT_REPORT_REQUEST,
      data
    };
  }
  function success(data) {
    return {
      type: salesPersonConstants.GET_SALESMANAGER_EXPORT_REPORT_SUCCESS,
      data
    };
  }
  function failure(error) {
    return {
      type: salesPersonConstants.GET_SALESMANAGER_EXPORT_REPORT_FAILURE,
      error
    };
  }
};

export const getCititesForReport = postaData => {
  return dispatch => {
    dispatch(request());
    salesPersonService.getCititesForReport(postaData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: salesPersonConstants.GET_CITIES_REPORT_REQUEST, data };
  }
  function success(data) {
    return { type: salesPersonConstants.GET_CITIES_REPORT_SUCCESS, data };
  }
  function failure(error) {
    return { type: salesPersonConstants.GET_CITIES_REPORT_FAILURE, error };
  }
};

export const getSalesPersonQuestDetail = quesID => {
  return dispatch => {
    dispatch(request());
    salesPersonService.getSalesPersonQuestDetail(quesID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return {
      type: salesPersonConstants.GET_SALESMANAGER_QUESDETAIL_REQUEST,
      data
    };
  }
  function success(data) {
    return {
      type: salesPersonConstants.GET_SALESMANAGER_QUESDETAIL_SUCCESS,
      data
    };
  }
  function failure(error) {
    return {
      type: salesPersonConstants.GET_SALESMANAGER_QUESDETAIL_FAILURE,
      error
    };
  }
};

export const updateAnswer = postData => {
  return dispatch => {
    salesPersonService.updateAnswer(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: salesPersonConstants.UPDATE_ANSWER_REQUEST, data };
  }
  function success(data) {
    return { type: salesPersonConstants.UPDATE_ANSWER_SUCCESS, data };
  }
  function failure(error) {
    return { type: salesPersonConstants.UPDATE_ANSWER_FAILURE, error };
  }
};

export const gethelpdetail = quesID => {
  return dispatch => {
    dispatch(request());
    salesPersonService.gethelpdetail(quesID).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: salesPersonConstants.GET_HELP_DETAIL_REQUEST, data };
  }
  function success(data) {
    return { type: salesPersonConstants.GET_HELP_DETAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: salesPersonConstants.GET_HELP_DETAIL_FAILURE, error };
  }
};

export const addHelpQuestion = postData => {
  return dispatch => {
    salesPersonService.addHelpQuestion(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: salesPersonConstants.ADD_HELP_QUESTION_REQUEST, data };
  }
  function success(data) {
    return { type: salesPersonConstants.ADD_HELP_QUESTION_SUCCESS, data };
  }
  function failure(error) {
    return { type: salesPersonConstants.ADD_HELP_QUESTION_FAILURE, error };
  }
};

export const updateHelpReply = postData => {
  return dispatch => {
    salesPersonService.updateHelpReply(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: salesPersonConstants.ADD_HELP_REPLY_REQUEST, data };
  }
  function success(data) {
    return { type: salesPersonConstants.ADD_HELP_REPLY_SUCCESS, data };
  }
  function failure(error) {
    return { type: salesPersonConstants.ADD_HELP_REPLY_FAILURE, error };
  }
};

export const getMonthandYear = () => {
  return dispatch => {
    dispatch(request());
    salesPersonService.getMonthandYear().then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: salesPersonConstants.GET_MONTH_YEAR_REQUEST, data };
  }
  function success(data) {
    return { type: salesPersonConstants.GET_MONTH_YEAR_SUCCESS, data };
  }
  function failure(error) {
    return { type: salesPersonConstants.GET_MONTH_YEAR_FAILURE, error };
  }
};

export const getProgressReport = postData => {
  return dispatch => {
    dispatch(request());
    salesPersonService.getProgressReport(postData).then(
      data => {
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: salesPersonConstants.GET_PROGRESS_REPORT_REQUEST, data };
  }
  function success(data) {
    return { type: salesPersonConstants.GET_PROGRESS_REPORT_SUCCESS, data };
  }
  function failure(error) {
    return { type: salesPersonConstants.GET_PROGRESS_REPORT_FAILURE, error };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/actions/salesPersonActions.js